import { useQuery } from '@tanstack/react-query';
import { http } from '../jobs/api/http';

/**
 * The factory, dated — optionally with a scenario laid on top.
 *
 * The plan holds no state on the server: it is recomputed from whatever is in
 * Redis plus whatever items are posted, every single call. So refetching IS the
 * update mechanism. Add a product, change a length, pull a drum out of a queue,
 * and the next answer simply reflects it. Nothing is written either way.
 */
export function useProductionPlan({
  items = [],
  project = true,
  queues = true,
  includeLive = true,
  fallbackSpeed = null
} = {}) {
  return useQuery({
    queryKey: ['production-plan', items, project, queues, includeLive, fallbackSpeed],
    queryFn: async () => {
      const { data } = await http.post('/api/redis/production-plan', {
        items,
        project,
        queues,
        includeLive,
        ...(fallbackSpeed ? { fallbackSpeed } : {})
      });
      return data;
    },
    refetchOnWindowFocus: false
  });
}
